import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { NAV_ITEMS } from '../data/site';
import { DemoCta } from './Alt6Shared';

export default function Alt6Nav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="a6-nav">
      <div className="a6-container a6-nav-inner">
        <Link to="/alt6" className="a6-wordmark" aria-label="Asha home">
          <span className="a6-wordmark-dot" aria-hidden="true" />
          Asha
        </Link>
        <nav className="a6-nav-links" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `a6-nav-link${isActive ? ' is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="a6-nav-cta">
          <DemoCta />
        </div>
        <button
          type="button"
          className="a6-nav-toggle"
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      <div className={`a6-nav-mobile${open ? ' is-open' : ''}`}>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `a6-nav-link${isActive ? ' is-active' : ''}`}
          >
            {item.label}
          </NavLink>
        ))}
        <DemoCta />
      </div>
    </header>
  );
}
